// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialCashLedgerState,
    CashLedgerSchema,
    CashLedgerFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const CashLedger = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [cash_ledger, setCashLedger] = useState(InitialCashLedgerState);
    const [formFields, setFormFields] = useState(CashLedgerFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && field.type === "select"
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getSchools = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("school_id", data);
        spinService.off();
    };

    const getCashLedger = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.CASH_LEDGERS + `/${id}`);
        const data = await response.json();
        setCashLedger(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewCashLedger = values.id === undefined;
        const url = isNewCashLedger ? EntityConstants.CASH_LEDGERS : EntityConstants.CASH_LEDGERS + `/${values.id}`;
        const method = isNewCashLedger ? post : put;
        const response = await method(url, { cash_ledger: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewCashLedger ? MessageContants.CASH_LEDGER_CREATED : MessageContants.CASH_LEDGER_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        getSchools();
        if (id !== undefined) {
            getCashLedger(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={cash_ledger}
            validationSchema={CashLedgerSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.CASH_LEDGER_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.CASH_LEDGER_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

CashLedger.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default CashLedger;
